"use client";

import { AutocompleteItem as HeroAutocompleteItem } from "@heroui/react";
import type React from "react";
import { cn } from "../../lib/utils";

// Get the original component props types
export type AutocompleteItemProps<T extends object> = React.ComponentProps<typeof HeroAutocompleteItem<T>> & {
  className?: string;
};

// Create the wrapper component
const AutocompleteItemWrapper = <T extends object>({
  className,
  classNames,
  children,
  ...props
}: AutocompleteItemProps<T>) => {
  return (
    <HeroAutocompleteItem
      {...props}
      classNames={{
        base: cn(className),
        ...classNames,
      }}
    >
      {children}
    </HeroAutocompleteItem>
  );
};

// Copy all static properties from the original component
Object.setPrototypeOf(AutocompleteItemWrapper, HeroAutocompleteItem);

// Copy static properties that HeroUI's collection system might need
Object.assign(AutocompleteItemWrapper, HeroAutocompleteItem);

// Ensure the component has the right displayName and type
AutocompleteItemWrapper.displayName =
  (HeroAutocompleteItem as React.ComponentType<unknown>).displayName || "AutocompleteItem";

// Copy the $$typeof symbol if it exists (React uses this for component identification)
if ("$$typeof" in HeroAutocompleteItem) {
  (AutocompleteItemWrapper as unknown as Record<string, unknown>).$$typeof = (
    HeroAutocompleteItem as unknown as Record<string, unknown>
  ).$$typeof;
}

// Export the wrapped component
export const AutocompleteItem = AutocompleteItemWrapper;
